import { createFileRoute } from '@tanstack/react-router';
import { CommentAutomationEditorPage } from '@/features/marketing';

/** Comment → DM automation editor — `/marketing/comment-dm/{id}`. */
export const Route = createFileRoute('/_auth/$orgId/marketing/comment-dm_/$automationId')({
  component: EditCommentAutomationRoute,
});

function EditCommentAutomationRoute() {
  const { orgId, automationId } = Route.useParams();
  return <CommentAutomationEditorPage orgId={orgId} automationId={automationId} />;
}
